export const tokenRequest = () => {
  const token = {
    headers: {
      authorization: `bearer ${localStorage.getItem("token")}`,
    },
  };
	return token;
}
